import React from 'react';
import { Card, Label } from 'semantic-ui-react';
import TruncateMarkup from 'react-truncate-markup';

export type BaseProps<T> = {
  title?: React.ReactNode;
  meta?: React.ReactNode;
  label?: string[];
  description?: React.ReactNode;
  extra?: React.ReactNode;
  onClick?: () => void;
} & T &
  RenderBaseArg;

export type RenderBaseArg = {
  headerCls?: string;
  labelCls?: string;
  metaCls?: string;
  descriptionCls?: string;
};

export default class Base<T> extends React.Component<BaseProps<T>, any> {
  renderHeader(args?: RenderBaseArg) {
    const { headerCls } = args || {};
    const { title } = this.props;

    return (
      title && (
        <Card.Header className={headerCls}>
          <TruncateMarkup lines={2}>
            <div>{title}</div>
          </TruncateMarkup>
        </Card.Header>
      )
    );
  }

  renderMeta(args?: RenderBaseArg) {
    const { metaCls } = args || {};
    const { meta } = this.props;

    return (
      meta && (
        <Card.Meta className={`mb-24 ${metaCls || ''} `}>{meta}</Card.Meta>
      )
    );
  }

  renderTags(args?: RenderBaseArg) {
    const { labelCls } = args || {};
    const { label } = this.props;

    return (
      !!label?.length && (
        <Label.Group className={labelCls}>
          {label.map((l, i) => (
            <Label key={i}>{l}</Label>
          ))}
        </Label.Group>
      )
    );
  }

  renderDescription(args?: RenderBaseArg) {
    const { descriptionCls } = args || {};
    const { description } = this.props;

    return (
      description && (
        <Card.Description className={descriptionCls}>
          {description}
        </Card.Description>
      )
    );
  }

  renderBase(args?: RenderBaseArg) {
    return (
      <Card.Content>
        {this.renderHeader(args)}
        {this.renderMeta(args)}
        {this.renderTags(args)}
        {this.renderDescription(args)}
      </Card.Content>
    );
  }

  render() {
    const { extra, onClick, metaCls, headerCls, labelCls, descriptionCls } =
      this.props;

    return (
      <Card fluid onClick={onClick}>
        {this.renderBase({ metaCls, headerCls, labelCls, descriptionCls })}
        {extra && <Card.Content extra>{extra}</Card.Content>}
      </Card>
    );
  }
}
